export default __webpack_public_path__ + "static/media/offer2.71a23fe7.png";